import { createSelector } from '@reduxjs/toolkit';
import { TRootState } from '../reducers';

export const navigationSelector = (state: TRootState) => state.navigation;

export const catalogueFiltersSelector = createSelector(navigationSelector, ({ categories: { list: categories } }) => ({
  categories,
}));

export const navigationMenuLinksSelector = (state: TRootState) => state.navigation.menuLinks;
